import MintUI from 'mint-ui'
// const openApp = () => {
//   var URL = window.location.search; //？xx=aa&yy=b  形式
//   if (URL) {
//     URL = URL.split('?')[1]; //获取参数列表
//     var map = {}; //key-value  保存参数和值
//     var params = URL.split('&');
//     for (var i = 0; i < params.length; i++) {
//       var ps = params[i].split('=');
//       map[ps[0]] = ps[1]; //添加
//     }
//     if (map.downloadApp == 'none') {
//       MintUI.Toast({
//         message: "暂不支持",
//         duration: 800,
//       })
//       return
//     }
//   }
//   var ua = navigator.userAgent.toLowerCase();
//   if (ua.match(/MicroMessenger/i) == "micromessenger") {
//     if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
//       window.location =
//         "https://itunes.apple.com/cn/app/apple-store/id1466586027";
//     } else if (navigator.userAgent.match(/android/i)) {
//       window.location =
//         "https://sj.qq.com/myapp/detail.htm?apkName=com.huyang.aidu";
//     } else {
//       window.location =
//       "http://h5.91idu.com/downLoadLCZM";
//     }
//   } else {
//     if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
//       var loadDateTime = new Date();
//       window.setTimeout(function () {
//         var timeOutDateTime = new Date();
//         if (timeOutDateTime - loadDateTime < 5000) {
//           window.location =
//             "https://itunes.apple.com/cn/app/apple-store/id1466586027";
//         } else {
//           window.close();
//         }
//       }, 2000);
//       window.location = "aidu://";
//     } else if (navigator.userAgent.match(/android/i)) {
//       var loadDateTime = new Date();
//       var state = window.open(
//         "add://articles:6666/articlesDetail?articleId=2",
//         "_blank"
//       );
//       window.setTimeout(function () {
//         var timeOutDateTime = new Date();
//         if (timeOutDateTime - loadDateTime < 5000) {
//           window.location =
//             "https://sj.qq.com/myapp/detail.htm?apkName=com.huyang.aidu";
//         } else {
//           window.close();
//         }
//       }, 2000);
//     } else {
//       if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
//         window.location =
//           "https://itunes.apple.com/cn/app/apple-store/id1466586027";
//       } else if (navigator.userAgent.match(/android/i)) {
//         window.location =
//           "https://sj.qq.com/myapp/detail.htm?apkName=com.huyang.aidu";
//       } else {
//         window.location =
//         "http://h5.91idu.com/downLoadLCZM";
//       }
//     }
//   }
// }

const openApp = () => {
  if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i) || navigator.userAgent.match(/android/i)) {
    var data = OpenInstall.parseUrlParams(); ///openinstall.js中提供的工具函数，解析url中的所有查询参数
    new OpenInstall(
      {
        /*appKey必选参数，openinstall平台为每个应用分配的ID*/
        appKey: "wzu7iw",
        /*自定义遮罩的html*/
        // mask:function(){
        //  return "<div id='_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
        // },
        /*OpenInstall初始化完成的回调函数，可选*/
        onready: function () {
          /*在app已安装的情况尝试拉起app*/
          this.schemeWakeup();

        
          this.wakeupOrInstall()
        }
      },
      data
    );
  } else {
    window.location =
      "http://h5.91idu.com/downLoadLCZM";
  }
 
}

export default openApp